import Swiper from "../../assets/.npm/node_modules/swiper";
import Pagination from "../../assets/.npm/node_modules/swiper/modules/pagination.min.mjs";

export default () => {
  let swiperCG = new Swiper(".cgSwiper", {
    modules: [Pagination],
    slidesPerView: "auto",
    spaceBetween: 0,
    loop: false,
    pagination: {
        el: ".cg-pagination",
        clickable: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 1.1,
        },
    
        576: {
          slidesPerView: 1.8,
        },
    
        992: {
            slidesPerView: "auto",
        }
      }
  });
}
  
